import React, { useContext,useState,useEffect, lazy, Suspense } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import Moment from 'react-moment';
import {FormatedPrice,Loading,DetailDossierFactureListe} from '@gull'
import { IsAuthContext } from 'app/App';
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import { Modal} from "react-bootstrap";

const RemoveItemsFromStock = lazy(() => import('../../../../../../@gull/components/form/RemoveItemsFromStock'));

const TopInfosDocument = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [sectionId,setSectionId] = useState('')
    const [sectionList,setSectionList] = useState([])
    const [validButton,setValidButton] = useState(false)
    const [validButtonRemoveItem,setValidButtonRemoveItem] = useState(false)
    const [data,setData] = useState({})

    const [selectedSection,setSelectedSection] = useState(false)
    const [selectedZone,setSelectedZone] = useState(false)
    const [obj,setObj] = useState({})

    const [totalItems,setTotalItems] = useState(0)

    const [showModal,setShowModal]=useState(false) 

    useEffect(function () {
        let quanyityItems = 0
        props.allInfos.facture_article_list.map(item=>{
            quanyityItems += +item.quantity
        })
        setTotalItems(quanyityItems)

    }, [props.allInfos.facture_article_list]) 

    useEffect(function () {
        if(props.allInfos.section!=null) setSectionId(props.allInfos.section_id)
        if(props.allInfos.section_list!=null) setSectionList(props.allInfos.section_list??[])
    }, [props.allInfos])

    useEffect(function () {
        //Construction du body envoyé pour assigner un document à une section
        if(sectionId!='') setData({section_id:sectionId})
    }, [sectionId])

    useEffect(function () {
        //Construction du body envoyé pour assigner un document à une section
        if(sectionList.length!=0) setData({section_list:sectionList})
    }, [sectionList])

    useEffect(function () {
        //Construction du body envoyé pour spécifier la zone de stockage dans laquel les articles du document seront retirés ou réintégré pour les bons de retour
        if(selectedZone) setObj({zone:selectedZone})

    }, [selectedZone])
    
    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let clientName = (Object.keys(props.clientDetail).length!=0 && props.clientDetail.name!= null) ? props.clientDetail.name : '';
    let clientFirstname = (Object.keys(props.clientDetail).length!=0 && props.clientDetail.firstname!= null) ? props.clientDetail.firstname : '';
    let clientId = (Object.keys(props.clientDetail).length!=0 ) ? props.clientDetail.id : '';

    const ConstructLinkDocumentTable = () => {//construction du tbody des docuement liés
        let ar = [];
        let go=true;
        let i=0;
        while(go){//on fait une boucle while tant qu'on trouve des docuements liés
            go=false
            let ligne= [];
            //enfant
            if(props.allInfos.childs_of.length>0){
                if(props.allInfos.childs_of[i]){
                    go=true;
                    ligne.push(props.allInfos.childs_of[i])
                }
                else ligne.push(false);
            }else{
                ligne.push(false)
            }
            //parent
            if(props.allInfos.parents_of.length!=0){
                if(props.allInfos.parents_of[i]){
                    go=true;
                    ligne.push(props.allInfos.parents_of[i])
                }
                else ligne.push(false);
            }else{
                ligne.push(false)
            }
            //facture d'acompte
            if(props.allInfos.link_with_child!=null && props.allInfos.link_with_child.filter(value=>value.type=='billingDeposit').length>0){
                let acompte = props.allInfos.link_with_child.filter(value=>value.type=='billingDeposit')
                if(acompte[i]){
                    go=true;
                    ligne.push(acompte[i])
                }
                else ligne.push(false);
            }//ici c'est normal qu'il n'y est pas un else avec un push car la colonne facture d'acompte ne s'affiche pas sur tous les documents

            ar.push(ligne)
            i++;
        }
        ar.pop()//on supprime la dernière ligne qui contient forcément que des données false

        const LinkDocument = ({id,bar,type}) => {
            const handleChangeDocument = () => {
                if(props.setId) props.setId(id)
                if(props.setTitleDocument) props.setTitleDocument({
                    bar:bar,
                    type:type
                })
            }

            if(props.from=='modal'){
                return(<Link onClick={() => handleChangeDocument()} to={"#"}>{bar}</Link>)
            }
            else return(<Link to={"/invoice/details/"+id}>{bar}</Link>)
        }

        return(
            <>
                {(ar.length!=0) ?
                    <small>
                        <table className="table mt-2 mb-0">
                            <thead className='bg-very-light'>
                                <tr>    
                                    <th>{t('childToDocument')}</th>
                                    <th>{t('parentToDocument')}</th>
                                    {(props.allInfos.type=='quotation' || props.allInfos.type=='purchaseOrderB2b') &&
                                        <th>{t('billingDeposit')}</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {ar.map((value,ind)=>
                                    <tr style={{border:'none'}} key={ind}>
                                        {value.map((val,ind2)=>
                                            <td style={{border:'none',paddingTop:0,paddingBottom:0}} key={ind2}>{(value) ? <LinkDocument id={val.id} bar={val.bar} type={val.type} /> : ''}</td>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <hr className="mt-0 pt-0 mb-4" />
                    </small>
                    :
                    false
                }
            </>
        )
    }

    const closeModal = () => {
        setShowModal(false)
    }

    const handleCheck = (e,id) => {
        if (e.target.checked && !sectionList.includes(id)) {
            setSectionList(prev=>
                [...prev,id]
            )
        }
        else {
            setSectionList(prev=>
                prev.filter(value => value!=id)
            )
        }
    }

    //pour phrase de raison d'attribution aux WMS
    let wmsStr={
        purchaseOrderB2b:'forCollect',
        deliveryNote:'forSignAndDelivery',
        returnNote:'forSotckReentry'
    }

    const TopStateDocument = (props) => {
        //si le document est annulé, quoi qu'il arrive on retourne que le document est annulé
        if(props.allInfos.cancelled){
            return(
                <h4 className='text-danger fw-bold'>{t('cancelledDocu')}</h4>
            )
        }

        //gestion des devis
        if(props.allInfos.type=='quotation'){
            return(<>
                {(props.allInfos.etat=='expired') && //si le devis est expiré 
                    <div className="alert alert-warning">{t('quotationExpireAt')} <Moment format="DD/MM/YYYY">{props.allInfos.date_limit}</Moment></div>
                }
                {(props.allInfos.etat_conversion=='notConverted') && //si le devis n'a donné lieu a aucune conversion
                    <div className="alert alert-secondary">{t('quotationNotConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='converted') && //si le devis n'a donné lieu a aucune conversion
                    <div className="alert alert-success">{t('quotationConverted')}</div>
                }
            </>)
        }

        //gestion des factures d'acompte
        if(props.allInfos.type=='billingDeposit'){
            return(<>
                {(props.allInfos.etat=='unUsed') && //si la facture d'accompte n'a pas été utilisée
                    <div className="alert alert-secondary">{t('billingDepositUnUsed')}</div>
                }
                {(props.allInfos.etat=='partiallyUsed') && //si la facture d'accompte n'a pas été utilisée
                    <div className="alert alert-warning">{t('billingDepositPartiallyUsed')}</div>
                }
                {(props.allInfos.etat=='used') && //si la facture d'accompte n'a pas été utilisée
                    <div className="alert alert-success">{t('billingDepositUsed')}</div>
                }
            </>)
        }

        //gestion des bons de commande
        if(props.allInfos.type=='purchaseOrderB2b'){
            return(<>
                {(props.allInfos.etat=='notCollected') && //non collecté
                    <div className="alert alert-secondary">{t('purchaseOrderB2bNotCollected')}</div>
                }
                {(props.allInfos.etat=='collectInProgress') && //partiellement collecté 
                    <div className="alert alert-warning">{t('purchaseOrderB2bPartialCollected')}</div>
                }
                {(props.allInfos.etat=='collected') && //collecté
                    <div className="alert alert-success">{t('purchaseOrderB2bCollected')}</div>
                }
                {(props.allInfos.etat_conversion=='notConverted') && //non converti
                    <div className="alert alert-secondary">{t('purchaseOrderB2bNotConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='partiallyConverted') && //partiellement converti
                    <div className="alert alert-warning">{t('purchaseOrderB2bPartialConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='converted') && //converti
                    <div className="alert alert-success">{t('purchaseOrderB2bConverted')}</div>
                }
            </>)
        }

        //gestion des bons de livraison
        if(props.allInfos.type=='deliveryNote'){
            return(<>
                {(props.allInfos.etat=='notDelivered') && //non livré 
                    <div className="alert alert-secondary">{t('deliveryNoteNotDelivery')}</div>
                }
                {(props.allInfos.etat=='delivered') && //livré 
                    <div className="alert alert-success">{t('deliveryNoteDelivery')}</div>
                }
                {(props.allInfos.etat_conversion=='notConverted') && //non converti
                    <div className="alert alert-secondary">{t('deliveryNoteNotConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='converted') && //converti 
                    <div className="alert alert-success">{t('deliveryNoteConverted')}</div>
                }
            </>)
        }

        //facture et facture d'achat
        if(props.allInfos.type=='billing' || props.allInfos.type=='billingBuy'){
            return(<>
                {(props.allInfos.etat=='notAcquitte') && //non acquité
                    <div className="alert alert-secondary">{t('invoiceNotAcquitte')}</div>
                }
                {(props.allInfos.etat=='partiallyAcquitte') && //partiellement acquité
                    <div className="alert alert-warning">{t('invoicePartiallyAcquitte')}</div>
                }
                {(props.allInfos.etat=='acquitte') && //acquité 
                    <div className="alert alert-success">{t('invoiceAcquitte')}</div>
                }
            </>)
        }

        //gestion des avoirs fournisseur
        if(props.allInfos.type=='creditNoteBuy'){
            return(<>
                {(props.allInfos.etat=='unUsed') &&
                    <div className="alert alert-secondary">{t('avoirUnUsed')}</div>
                }
                {(props.allInfos.etat=='partiallyUsed') &&
                    <div className="alert alert-warning">{t('avoirPartiallyUsed')}</div>
                }
                {(props.allInfos.etat=='used') &&
                    <div className="alert alert-success">{t('avoirUsed')}</div>
                }
                {(props.allInfos.etat_conversion=='notConverted') &&
                    <div className="alert alert-secondary">{t('avoirNotConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='partiallyConverted') &&
                    <div className="alert alert-warning">{t('avoirPartialConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='converted') &&
                    <div className="alert alert-success">{t('avoirConverted')}</div>
                }
            </>)
        }

        //gestion des avoirs
        if(props.allInfos.type=='creditNote'){
            return(<>
                {(props.allInfos.etat=='unUsed') && //non utilisé
                    <div className="alert alert-secondary">{t('avoirUnUsed')}</div>
                }
                {(props.allInfos.etat=='partiallyUsed') && //partiellement utilisé 
                    <div className="alert alert-warning">{t('avoirPartiallyUsed')}</div>
                }
                {(props.allInfos.etat=='used') && //complètement utilisé
                    <div className="alert alert-success">{t('avoirUsed')}</div>
                }
                {(props.allInfos.etat_conversion=='notConverted') && //non converti
                    <div className="alert alert-secondary">{t('avoirNotConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='partiallyConverted') && //partiellement converti
                    <div className="alert alert-warning">{t('avoirPartialConverted')}</div>
                }
                {(props.allInfos.etat_conversion=='converted') && //converti
                    <div className="alert alert-success">{t('avoirConverted')}</div>
                }
            </>)
        }

        //gestion des bons de retour
        if(props.allInfos.type=='returnNote'){
            return(<>
                {(props.allInfos.etat=='notCollected') && //non collecté
                    <div className="alert alert-secondary">{t('returnNoteNotCollected')}</div>
                }
                {(props.allInfos.etat=='collectInProgress') && //partiellement collecté
                    <div className="alert alert-warning">{t('returnNotePartialCollected')}</div>
                }
                {(props.allInfos.etat=='collected') && //collecté
                    <div className="alert alert-success">{t('returnNoteCollected')}</div>
                }
            </>)
        }

        //au cas où on ne retourne rien
        return(<></>)
    }

    //pour assombrir la modal du document
    useEffect(function (){
        if(props.setBrownDocumentModal){
            if(showModal) props.setBrownDocumentModal(true)
            else props.setBrownDocumentModal(false)
        }
    },[showModal])
    //end

    return (
        <div>
            <Modal size="xl" show={showModal} onHide={()=>closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('folder')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DetailDossierFactureListe folderId={showModal} bigLoader={false} linkOnCLient={true} from={props.from} id={props.id} setId={props.setId} setTitleDocument={props.setTitleDocument}/>
                </Modal.Body>
            </Modal>
            {/*bloc indiquant le status du document*/}
            <div className="col-row">
                <div className="col-12">
                    <div className='mb-2'>
                        <TopStateDocument allInfos={props.allInfos} />
                        <hr/>
                    </div>
                </div>
            </div>
            {/*end*/}
            {/*bloc indiquant le client et la date*/}
            <div className="row mb-2">
                <div className="col-6">
                    <h5 className='fw-bold text-muted'>
                        <Link to={'/invoice/client/detail/'+clientId}>{clientName+' '+clientFirstname}</Link>
                    </h5>
                </div>
                <div className="col-6">
                    <h6 className='fw-bold'>
                        {t('emisLe')} <Moment format="DD/MM/YYYY">{props.allInfos.date_finalisation}</Moment>
                    </h6>
                </div>
            </div>
            {/*end*/}
            {/*infos divers*/}
            <div className="row">
                <div className="col-6">
                    <h6 className="fw-bold">
                        {t('amountTtc')+' : '} <span className="text-muted"><FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={props.allInfos.ttc} /></span><br/>
                        {(props.allInfos.type!='billingDeposit') &&
                            <>
                                <span className="text-muted">{props.allInfos.facture_article_list.length+' '+t('row')+'(s)'}</span><br/>
                                <span className="text-muted">{totalItems+' '+t('item')+'(s)'}</span>
                            </>
                        }
                    </h6>
                </div>
                <div className="col-6">
                    <h6 className="fw-bold">
                        {props.allInfos.dossier_b2b!=null &&
                            <>{t('folder')+' n° : '} 
                                <div>
                                    {props.allInfos.dossier_b2b.map(dossier => {
                                        return <div key={dossier.id}><button className="btn btn-link p-0 text-decoration-none text-primary" onClick={()=>setShowModal(dossier.id)}>{dossier.nbr+' - '+dossier.name}</button><br/></div>
                                    })}
                                    <br/>
                                </div>
                            </>
                        }
                        {(props.allInfos.alert_date && props.allInfos.alert_date!=null) &&
                            <>{t('programedReminder')+' : '} <span className="text-muted"><Moment format="DD/MM/YYYY">{props.allInfos.alert_date}</Moment></span><br/></>
                        }
                    </h6>
                </div>
            </div>
            {/*end*/}
            {/*Note*/}
            {(props.allInfos.divers_infos?.note && props.allInfos.divers_infos.note!='') &&
                <div className="alert alert-primary" dangerouslySetInnerHTML={{ __html: '<b>'+t('noteInterne')+':</b><br>'+props.allInfos.divers_infos.note }}></div>
            }
            {/*end*/}
            {/*tableau des docuements liés*/}
            {(props.allInfos.type!='billingDeposit') &&
                 <ConstructLinkDocumentTable />
            }  
            {/*end*/}
            {/*origine de la facture d'acompte*/}
            {props.allInfos.link_with_parent!=null &&
                <div className='mb-2'>
                    {(props.allInfos.type=='billingDeposit') &&
                        <>
                            <span className='fw-bold d-block'>{t('fromDocument')}: <span className="text-muted">{t(props.allInfos.link_with_parent.type)} - </span><Link to={"/invoice/details/"+props.allInfos.link_with_parent.id}>{props.allInfos.link_with_parent.bar}</Link></span>
                        </>
                    }
                </div>
            }
            {/*end*/}
            {/*utilisation de la facture d'acompte ou de l'avoir*/}
            {(props.allInfos.used_link!=null && (Array.isArray(props.allInfos.used_link) && props.allInfos.used_link.length!=0)) ?
                <div className='mb-2'>
                    <div className='mb-2'>
                        <span className='fw-bold d-block'>{t('usedOnDoc')}</span>
                        {props.allInfos.used_link.map(value=>{
                            return(
                                <div key={value.id}>
                                    <span className="d-block" key={value.id}>
                                        <Link to={"/invoice/details/"+value.id}>{value.bar}</Link>&nbsp;&nbsp;
                                        <span className="text-muted"><FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={props.allInfos.used_amount[value.id]??0} /></span>
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                    <div>
                        <span className='fw-bold d-block'>{t('amountLeft')}</span>
                        <span className="text-muted"><FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={props.allInfos.used_amount['disponible']??0} /></span>
                    </div>
                </div>
            :
                false
            }
            {/*end*/}
            {/*origine du bond de commande fournisseur*/}
            {props.allInfos.po!=null &&
                <div className='mb-2'>
                    <>
                        <span className='fw-bold d-block'>{t('generatedByPurchaseOrder')} : <Link to={"/erp/purchase-order/details/"+props.allInfos.po.id}>{props.allInfos.po.name}</Link></span>
                    </>
                </div>
            }
            {/*end*/}
            {/*attribution wms*/}
            {(((props.allInfos.type=='returnNote' && props.allInfos.etat!='collected') || (props.allInfos.type=='deliveryNote' && props.allInfos.etat!='delivered')) && props.allInfos.cancelled==0 && props.moduleFacturation.params.wms.active) &&
                <div className='p-2 bg-very-light rounded mb-2'>
                    <label className="bold">{t('assignAWms')} {(wmsStr[props.allInfos.type]) && t(wmsStr[props.allInfos.type])}</label>
                    <div className='col-12'>
                        <select value={sectionId} className='form-control form-control-sm' onChange={(e)=>setSectionId(Number(e.target.value))}>
                            <option value="">-- Select --</option>
                            {props.company.section && props.company.section.map(value=>{
                                if(value.type!='ecommerce'){
                                    return(
                                        <option key={value.id} value={value.id}>{value.name}</option>
                                    )
                                }
                            })}
                        </select>&nbsp;
                        <button 
                            disabled={sectionId=='' || validButton} 
                            className='btn btn-sm btn-primary mt-2' 
                            onClick={()=>props.constructionDocument(setValidButton,props.id,false,t,data,props.setItemsBilling,props.setAllInfos)}
                        >
                            {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                        </button>
                    </div>
                </div>
            }
            {(props.allInfos.type=='purchaseOrderB2b' && props.allInfos.cancelled==0 && props.allInfos.etat!='collected' && props.moduleFacturation.params.wms.active) &&
                <div className='p-2 bg-very-light rounded mb-2'>
                    <label className="bold">{t('assignAWms')} {(wmsStr[props.allInfos.type]) && t(wmsStr[props.allInfos.type])}</label>
                    <div className='row form-group'>
                        {(Object.keys(props.company).length!=0 && props.company.section.length!=0) && props.company.section.map((section)=>
                            <div key={section.id} className="col-6 d-flex justify-content-center">
                                <label htmlFor={section.id} className="form-check-label">{section.name}</label>&nbsp;
                                <input type="checkbox" id={section.id} checked={sectionList.includes(section.id)} className='form-check-input' onChange={(e) => handleCheck(e,section.id)}/>
                            </div>
                        )}
                    </div>
                    <button 
                        disabled={sectionList.length==0 || validButton} 
                        className='btn btn-sm btn-primary mt-2' 
                        onClick={()=>props.constructionDocument(setValidButton,props.id,false,t,data,props.setItemsBilling,props.setAllInfos)}
                    >
                        {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                    </button>
                </div>
            }
            {/*end*/}
            {/*sortie ou entrée en stock*/}
            {((props.allInfos.type=='purchaseOrderB2b' || props.allInfos.type=='billing' || props.allInfos.type=='returnNote') && !props.allInfos.stock && !props.allInfos.inter_societe) &&
                <div className='mt-2 p-2 bg-very-light rounded'>
                    <Suspense fallback={<Loading></Loading>}>
                        <RemoveItemsFromStock 
                            documentType={props.allInfos.type}
                            selectedSection={selectedSection}
                            setSelectedSection={setSelectedSection}
                            selectedZone={selectedZone}
                            setSelectedZone={setSelectedZone}
                            validButton={validButtonRemoveItem}
                            company={props.company}
                        />
                    </Suspense>
                    <button 
                        disabled={!selectedZone || validButtonRemoveItem} 
                        className='btn btn-sm btn-primary' 
                        onClick={() => {
                            swal
                            .fire({
                                title: props.allInfos.type=='returnNote' ? t('confirmReinstateItemsInStock')+"?" : props.allInfos.type=='billing' ? t('confirmRemoveItemsFromStock')+' ?' : t('confirmCollectItem')+' ?',
                                icon: "warning",
                                type: "question",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: t('btnYes'),
                                cancelButtonText: t('btnNo'),
                            })
                            .then((result) => {
                                if (result.value) {
                                    props.constructionDocument(setValidButtonRemoveItem,props.id,false,t,obj,props.setItemsBilling,props.setAllInfos)
                                }
                            });
                        }}
                    >
                        {validButtonRemoveItem ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                    </button>
                </div>
            }
            {/*end*/}
        </div>
    )
};

export default TopInfosDocument;